/* open external links in new tab */
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/***************************
 * Variant picker selection *
 ***************************/

document.addEventListener('DOMContentLoaded', function () {
  const pageType = window.themeVariables.settings.pageType;
  const productType = window.themeVariables.product.type;
  const showQuickBuy = window.themeVariables.settings.showQuickBuy;
  const selectors = document.querySelectorAll('[data-size-selected]');
  const isBundle = productType === 'Bundle';

  if (pageType == 'product') {
    handleProductPage();
  }
  // Product cards need handling where ever collection-sections exist,
  // also check wether quick-buy is enabled
  if (selectors && showQuickBuy) {
    handleProductCards();
  }

  function setSelected(element) {
    const optionName = element.name;

    document.querySelectorAll('[data-size-selected]').forEach((selector) => {
      if (!isBundle) {
        // normal product → only one size total
        selector.removeAttribute('data-size-selected');
        return;
      }

      // bundle → only clear sizes from the same option group
      if (selector.name === optionName) {
        selector.removeAttribute('data-size-selected');
      }
    });

    element.setAttribute('data-size-selected', 'selected');
    document.dispatchEvent(
      new CustomEvent('variant:ui-selected', { bubbles: true }),
    );
  }

  function hasSelectedAttribute() {
    return Array.from(selectors).some((selector) => {
      if (!isBundle) {
        return (
          selector.name === 'option2' &&
          selector.getAttribute('data-size-selected') === 'selected'
        );
      }
      return selector.getAttribute('data-size-selected') === 'selected';
    });
  }

  function createVariantErrorButton() {
    const variantErrorButton = document.createElement('button');
    variantErrorButton.classList.add('button', 'w-full');
    variantErrorButton.id = 'variant-error-button';
    variantErrorButton.innerText =
      window.themeVariables.strings.addToCartButton;
    return variantErrorButton;
  }

  function addVariantErrorButtonListener(
    button,
    variantErrorElement,
    variantError,
  ) {
    button.addEventListener('click', function (e) {
      // Display the reminder
      e.preventDefault();
      variantErrorElement.style.paddingBottom = '1rem';
      variantErrorElement.classList.add('fade-in-fwd');
      variantErrorElement.innerText = variantError;
      setTimeout(
        () => variantErrorElement.classList.remove('fade-in-fwd'),
        500,
      );
    });
  }

  function addSizeSelectorClickListeners(options) {
    options.selectors.forEach((selector) => {
      selector.addEventListener('click', function () {
        setSelected(this);

        options.variantErrorElement.classList.add('fade-out-bck');
        setTimeout(() => {
          options.variantErrorElement.remove();
          options.variantErrorButton.remove();
          options.atc.style.display = 'block';
        }, 500);
      });
    });
  }

  function handleProductPage() {
    const variantErrorElement = document.querySelector(
      '#variant-selection-warning',
    );
    const buyButtons = document.querySelector('.buy-buttons');
    const atc = buyButtons.querySelector('button[type="submit"]');
    const variantError = window.themeVariables.strings.variantError;
    const productAvailable = window.themeVariables.product.available;
    const variantErrorButton = createVariantErrorButton();

    if (!isBundle && selectors.length === 1) {
      setSelected(selectors[0]);
      return;
    }

    const form = atc.closest('form');

    function requireSizeSelection(e) {
      // if product has sizes and is available and user hasn't selected size in YOUR UI
      if (productAvailable && selectors.length > 0 && !hasSelectedAttribute()) {
        e.preventDefault();
        e.stopPropagation();

        // show the same warning you show when clicking the reminder button
        variantErrorButton.click();

        // optional: scroll to picker
        document
          .querySelector('[data-block-type="variant-picker"]')
          ?.scrollIntoView({ block: 'center' });
      }
    }

    // capture phase so we block even if theme attaches other submit handlers
    form?.addEventListener('submit', requireSizeSelection, true);

    // Exclude instances where only one or no size-options, e.g. gift cards, and product not sold out completely
    if (selectors.length > 0) {
      if (!hasSelectedAttribute() && productAvailable) {
        // Replace the atc-button with the reminder - button if no variant selected
        // Fixed bug where multiple variant-error-buttons were created only on Firefox
        const existingErrorButton = buyButtons.querySelector(
          '#variant-error-button',
        );
        if (!existingErrorButton) {
          atc.style.display = 'none';
          buyButtons.appendChild(variantErrorButton);
        }
      }

      addVariantErrorButtonListener(
        variantErrorButton,
        variantErrorElement,
        variantError,
      );

      // After selecting variant: fade out the error-text, remove the reminder elements and bring back the real atc
      addSizeSelectorClickListeners({
        selectors: selectors,
        variantErrorElement: variantErrorElement,
        variantErrorButton: variantErrorButton,
        atc: atc,
      });
    }
  }

  function handleProductCards() {
    const productCards = document.querySelectorAll('.product-card');
    productCards.forEach((card) => {
      const modalOpenButton = card.querySelector(
        '.product-card__quick-add-button',
      );
      // button does not exist on sold out products
      if (modalOpenButton) {
        modalOpenButton.addEventListener('click', function () {
          handleModalOpen(card);
        });
      }
    });

    function handleModalOpen(card) {
      const modal = card.querySelector('quick-buy-modal');
      if (!modal) return;
      // Observe opening the modal
      const observer = new MutationObserver((mutationsList, observer) => {
        handleMutations(mutationsList, observer, modal);
      });

      observer.observe(modal, { childList: true });
    }

    function handleMutations(mutationsList, observer, modal) {
      for (let mutation of mutationsList) {
        if (mutation.addedNodes.length) {
          const content = modal.querySelector('.quick-buy-modal__content');

          if (content) {
            handleContentFound(content, observer);
          }
        }
      }
    }

    function hasSelectedAttribute(selectors) {
      return Array.from(selectors).some((selector) => {
        if (!isBundle) {
          return (
            selector.name === 'option2' &&
            selector.hasAttribute('data-size-selected')
          );
        }
        return selector.hasAttribute('data-size-selected');
      });
    }

    function handleContentFound(content, observer) {
      const variantErrorElement = content.querySelector(
        '#variant-selection-warning',
      );
      const variantErrorButton = createVariantErrorButton();
      const variantError = window.themeVariables.strings.variantError;
      const variantPicker = content.querySelector(
        '[data-block-type="variant-picker"]',
      );
      const buyButtons = content.querySelector('.buy-buttons');
      const atc = content.querySelector('button[type="submit"]');
      const selectors = variantPicker.querySelectorAll('[data-size-selected]');

      if (selectors.length > 0) {
        if (!hasSelectedAttribute(selectors)) {
          atc.style.display = 'none';
          buyButtons.appendChild(variantErrorButton);
        }

        addVariantErrorButtonListener(
          variantErrorButton,
          variantErrorElement,
          variantError,
        );
        addSizeSelectorClickListeners({
          selectors: selectors,
          variantErrorElement: variantErrorElement,
          variantErrorButton: variantErrorButton,
          atc: atc,
        });
      }

      observer.disconnect();
    }
  }
});

/* ONESIZE - product quick-buy notification */
function handleOnesizeNotification() {
  const productCards = document.querySelectorAll(
    'product-card:not(.nosto-item)',
  );
  productCards.forEach((card) => {
    if (card.querySelector('quick-buy-modal')) return;
    const form = card.querySelector('form[action*="/cart/add"]');
    if (!form) return; // Ensure form exists
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const targetNode = card.querySelector('.product-card__figure');
      const bannerElement = `<div class="product-card__quick-add-notification banner banner--success" role="alert">
          <div class="product-card__quick-add-notification-text">
            <span class="product-card__quick-add-notification-text--bold">${window.themeVariables.strings.addedToCart}</span>
          </div>
        </div>`;
      targetNode.insertAdjacentHTML('beforeend', bannerElement);
      const notification = targetNode.querySelector(
        '.product-card__quick-add-notification',
      );
      setTimeout(() => {
        notification.remove();
      }, 2500);
    });
  });
}

handleOnesizeNotification();

/* Free gift */

function addFreeGift(giftType) {
  switch (giftType) {
    case 'value':
      var giftId = window.themeVariables.settings.freeGiftProduct;
      var giftMessage = window.themeVariables.settings.freeGiftMessage;
      break;
    case 'tag':
      var giftId = window.themeVariables.settings.freeGiftProductTag;
      var giftMessage = window.themeVariables.settings.freeGiftTagMessage;
      break;
    case 'product':
      var giftId = window.themeVariables.settings.freeGiftProductId;
      var giftMessage = window.themeVariables.settings.freeGiftIdsMessage;
      break;
  }

  if (giftId == '' || giftId == 'undefined') {
    return;
  }

  var freebies = {
    items: [
      {
        quantity: 1,
        id: giftId,
        properties: {
          '__Free gift': giftType,
          __gift_message: giftMessage,
        },
      },
    ],
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(freebies),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(() => {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        }),
      );

      if (window.location.pathname === '/cart') {
        window.location.reload();
      }
    })
    .catch((error) => {
      console.log('Fetch error:', error);
    });
}

function removeFreeGift(RemoveFreeGifts) {
  var updates = {};

  for (let i = 0; i < RemoveFreeGifts.length; i++) {
    let giftType = RemoveFreeGifts[i];
    let giftId;

    switch (giftType) {
      case 'value':
        giftId = window.themeVariables.settings.freeGiftProduct;
        break;
      case 'tag':
        giftId = window.themeVariables.settings.freeGiftProductTag;
        break;
      case 'product':
        giftId = window.themeVariables.settings.freeGiftProductId;
        break;
    }

    if (giftId !== undefined) {
      updates[giftId] = 0;
    }
  }

  if (Object.keys(updates).length > 0) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          }),
        );

        if (window.location.pathname === '/cart') {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log('Fetch error:', error);
      });
  }
}

document.addEventListener('cart:change', function (event) {
  /* free gift when product x is in cart, cart value is x or product from collection x is added to cart */
  // check cart total
  fetch('/cart.js')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((cart) => {
      let total = parseInt(cart.total_price);
      var valueFreeGiftAdded = false;
      var tagFreeGiftAdded = false;
      var productFreeGiftAdded = false;
      var freeGiftTags = window.themeVariables.settings.freeGiftTags.split(',');
      var freeGiftIds = window.themeVariables.settings.freeGiftIds.split(',');
      var cartProducts = [];
      var cartTags = [];
      var enableFreeGift = window.themeVariables.settings.enableFreeGift;
      var removeFreeGifts = [];

      cart.items.forEach((item) => {
        cartProducts.push(item.variant_id.toString());

        if (item.properties['__Free gift'] === 'value') {
          valueFreeGiftAdded = true;
        }

        if (item.properties['__Free gift'] === 'tag') {
          tagFreeGiftAdded = true;
        }

        if (item.properties['__Free gift'] === 'product') {
          productFreeGiftAdded = true;
        }
      });

      // free gift based on cart value
      if (enableFreeGift === true) {
        var limit =
          parseInt(window.themeVariables.settings.freeGiftLimit) * 100;

        if (event.detail.cart.items_removed) {
          if (event.detail.cart.items_removed.length === 0) {
            if (
              total >= limit &&
              valueFreeGiftAdded === false &&
              enableFreeGift
            ) {
              setTimeout(() => {
                addFreeGift('value');
              }, 1000);
            }
          }
        } else {
          if (
            total >= limit &&
            valueFreeGiftAdded === false &&
            enableFreeGift
          ) {
            setTimeout(() => {
              addFreeGift('value');
            }, 1000);
          }
        }

        if (valueFreeGiftAdded === true) {
          if (total < limit) {
            removeFreeGifts.push('value');
          }
        }
      }

      // free gift based on product
      if (productFreeGiftAdded === true) {
        // if there is no free gift related product(s) anymore, remove free gift
        if (!freeGiftIds.some((e) => cartProducts.includes(e))) {
          removeFreeGifts.push('product');
        }
      }

      // remove free gift if tag is not exist in cart products
      if (tagFreeGiftAdded === true) {
        document
          .querySelectorAll('[data-carttags]')
          .forEach((el) =>
            Array.prototype.push.apply(
              cartTags,
              el.dataset.carttags.split(','),
            ),
          );

        if (!freeGiftTags.some((e) => cartTags.includes(e))) {
          removeFreeGifts.push('tag');
        }
      }

      if (removeFreeGifts.length > 0) {
        removeFreeGift(removeFreeGifts);
      }
    })
    .catch((error) => {
      console.log('Fetch error:', error);
    });
});

document.addEventListener('variant:add', function (event) {
  var enableFreeGiftTag = window.themeVariables.settings.enableFreeGiftTag;
  var enableFreeGiftId = window.themeVariables.settings.enableFreeGiftId;
  var freeGiftTags = window.themeVariables.settings.freeGiftTags.split(',');
  var freeGiftIds = window.themeVariables.settings.freeGiftIds.split(',');
  var productTags = event.detail.productTags.map((tag) => tag.toLowerCase());
  var productId = event.detail.items[0].variant_id.toString();
  var idFreegiftEnabled = false;
  var tagFreegiftEnabled = false;
  var tagFreeGiftAdded = false;
  var idFreeGiftAdded = false;

  fetch('/cart.js')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((cart) => {
      cart.items.forEach((item) => {
        if (
          item.properties['__Free gift'] === 'tag' &&
          tagFreeGiftAdded === false
        ) {
          tagFreeGiftAdded = true;
        }

        if (
          item.properties['__Free gift'] === 'product' &&
          idFreeGiftAdded === false
        ) {
          idFreeGiftAdded = true;
        }
      });

      if (enableFreeGiftTag === true && tagFreeGiftAdded === false) {
        if (
          productTags &&
          productTags.length > 0 &&
          freeGiftTags &&
          freeGiftTags.length > 0
        ) {
          if (productTags.some((item) => freeGiftTags.includes(item))) {
            tagFreegiftEnabled = true;
          }
        }

        if (tagFreegiftEnabled === true) {
          addFreeGift('tag');
        }
      }

      if (enableFreeGiftId === true && idFreeGiftAdded === false) {
        if (freeGiftIds.includes(productId)) {
          idFreegiftEnabled = true;
        }

        if (idFreegiftEnabled === true) {
          addFreeGift('product');
        }
      }
    })
    .catch((error) => {
      console.log('Fetch error:', error);
    });
});

/* add event details to datalayer for analyzify */
document.addEventListener('variant:add', function (event) {
  var formElement = event.target;

  var productJsonElement = event.target.querySelector('[data-product-json]');

  if (productJsonElement) {
    var productJson = JSON.parse(productJsonElement.innerHTML);
  }

  if (productJson) {
    var quantityInput = formElement.querySelector('input[name="quantity"]');
    var itemQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    var variantInput = formElement.querySelector('*[name="id"]');
    var selectedVariant = variantInput ? variantInput.value || '' : '';
    var price = productJson.product.price / 100;
    var collection = productJson.product_collection.collection;

    window.dataLayer.push({
      event: 'ee_addToCart',
      name: productJson.product.title,
      id: productJson.product.id.toString(),
      price: price.toString(),
      brand: productJson.product.vendor,
      product_type: productJson.product.type,
      category: collection,
      quantity: itemQuantity.toString(),
      variant: selectedVariant,
      g_product_id:
        'shopify_FI_' + productJson.product.id + '_' + selectedVariant,
    });
  }
});

(function () {
  const filterRemovedTemplate = window.themeVariables?.strings?.filterRemoved;
  if (!filterRemovedTemplate) return;

  const liveRegion = document.createElement('span');
  liveRegion.id = 'facet-live-region';
  liveRegion.className = 'sr-only';
  liveRegion.setAttribute('role', 'status');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  document.body.appendChild(liveRegion);

  const announceFilterRemoved = (filterName) => {
    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = filterRemovedTemplate.replace('@@', filterName);
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.removable-facet a[is="facet-link"]');
    if (!link?.dataset.filterName) return;
    announceFilterRemoved(link.dataset.filterName);
  });
})();

(function () {
  const INTERACTIVE_SELECTOR =
    'a, button, video, model-viewer, iframe, [tabindex]:not([tabindex="-1"])';

  const announce = (liveRegion, message) => {
    if (!liveRegion || !message) return;
    liveRegion.textContent = '';
    requestAnimationFrame(() => {
      liveRegion.textContent = message;
    });
  };

  const syncCellAccessibility = (cell, isVisible) => {
    if (cell.hasAttribute('hidden')) return;

    cell.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    cell.querySelectorAll(INTERACTIVE_SELECTOR).forEach((element) => {
      if (isVisible) {
        element.removeAttribute('tabindex');
      } else {
        element.setAttribute('tabindex', '-1');
      }
    });
  };

  const initCarouselAccessibility = (carousel) => {
    if (carousel.dataset.a11yInit === 'true') return;
    carousel.dataset.a11yInit = 'true';

    const getCells = () =>
      carousel.querySelectorAll('.product-gallery__media:not([hidden])');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          syncCellAccessibility(
            entry.target,
            entry.isIntersecting && entry.intersectionRatio >= 0.5,
          );
        });
      },
      { root: carousel, threshold: [0, 0.5, 1] },
    );

    const observeCells = () => {
      observer.disconnect();
      getCells().forEach((cell) => observer.observe(cell));
    };

    observeCells();
    carousel.addEventListener('carousel:filter', observeCells);

    const gallery = carousel.closest('product-gallery');
    const liveRegion = gallery?.querySelector('.product-gallery__live-region');

    carousel.addEventListener('carousel:settle', (event) => {
      observeCells();

      const cell = event.detail?.cell;
      if (!cell) return;

      const positionLabel = cell.getAttribute('aria-label');
      const imageAlt = cell.querySelector('img')?.alt?.trim();
      announce(
        liveRegion,
        imageAlt && positionLabel
          ? `${positionLabel}: ${imageAlt}`
          : positionLabel || imageAlt,
      );
    });
  };

  const initProductGallery = (gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (carousel) initCarouselAccessibility(carousel);
  };

  const initAllProductGalleries = (root = document) => {
    root.querySelectorAll('product-gallery').forEach(initProductGallery);
  };

  const initPhotoSwipeAccessibility = (pswp) => {
    if (pswp.dataset.a11yInit === 'true') return;
    pswp.dataset.a11yInit = 'true';

    const carouselLabel =
      window.themeVariables?.strings?.carousel || 'Image carousel';
    pswp.setAttribute('aria-roledescription', carouselLabel);

    const scrollWrap = pswp.querySelector('.pswp__scroll-wrap') || pswp;
    const liveRegion = document.createElement('span');
    liveRegion.className = 'sr-only';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    pswp.appendChild(liveRegion);

    const itemObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const item = entry.target;
          const isVisible =
            entry.isIntersecting && entry.intersectionRatio >= 0.5;

          item.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

          if (!isVisible) return;

          const imageAlt = item.querySelector('img')?.alt?.trim();
          if (imageAlt) announce(liveRegion, imageAlt);
        });
      },
      { root: scrollWrap, threshold: [0, 0.5, 1] },
    );

    pswp.querySelectorAll('.pswp__item').forEach((item) => {
      itemObserver.observe(item);
    });
  };

  const init = () => {
    initAllProductGalleries();
    document.querySelectorAll('.pswp').forEach(initPhotoSwipeAccessibility);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;

        if (node.matches?.('product-gallery')) initProductGallery(node);
        node.querySelectorAll?.('product-gallery').forEach(initProductGallery);

        if (node.matches?.('.pswp')) initPhotoSwipeAccessibility(node);
        node.querySelectorAll?.('.pswp').forEach(initPhotoSwipeAccessibility);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

class FaqTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    if (!this.tabs.length) return;

    this.panels = this.tabs
      .map((tab) => document.getElementById(tab.getAttribute('aria-controls')))
      .filter(Boolean);

    this.mediaQuery = window.matchMedia('(min-width: 1000px)');
    this.mediaQuery.addEventListener('change', () => this.updatePanelVisibility());

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });

    this.updatePanelVisibility();
  }

  get isTabLayout() {
    return this.mediaQuery.matches;
  }

  updatePanelVisibility() {
    if (!this.isTabLayout) {
      this.panels.forEach((panel) => {
        panel.hidden = false;
      });
      return;
    }

    const activeTab =
      this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
      this.tabs[0];
    this.activateTab(activeTab);
  }

  activateTab(tab) {
    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.setAttribute('tabindex', selected ? '0' : '-1');
      item.classList.toggle('is-active', selected);
    });

    if (this.isTabLayout) {
      const panelId = tab.getAttribute('aria-controls');
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });
    }
  }

  onKeydown(event) {
    if (!this.isTabLayout) return;

    const tab = event.target;
    const index = this.tabs.indexOf(tab);
    if (index === -1) return;

    let nextIndex = index;

    switch (event.key) {
      case 'ArrowDown':
        nextIndex = (index + 1) % this.tabs.length;
        break;
      case 'ArrowUp':
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        this.activateTab(tab);
        return;
      default:
        return;
    }

    event.preventDefault();
    this.tabs[nextIndex].focus();
  }
}

if (!window.customElements.get('faq-tabs')) {
  window.customElements.define('faq-tabs', FaqTabs);
}

(function () {
  const storesList = document.getElementById('stores-list');
  if (!storesList) return;

  const mapSection = document.querySelector('.shopify-section--apps');
  if (!mapSection) return;

  mapSection.setAttribute('aria-hidden', 'true');

  if ('inert' in HTMLElement.prototype) {
    mapSection.inert = true;
  } else {
    mapSection
      .querySelectorAll(
        'a, button, input, select, textarea, iframe, [tabindex]',
      )
      .forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
  }
})();
